import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Box } from '@material-ui/core';
import FileDownload from './FileDownload';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(0.5),
    minWidth: 120,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  emptyState: {
    fontSize: '0.75rem',
    color: theme.palette.text.secondary,
    fontStyle: 'italic',
  },
}));

const ContestacaoOutputDisplay = ({ outputPayload, status }) => {
  const classes = useStyles();

  // Se não há outputPayload ou não há result_docx, mostrar `-` centralizado
  if (!outputPayload || !outputPayload.result_docx) {
    return (
      <Box className={classes.container}>
        <Typography className={classes.emptyState}>
          -
        </Typography>
      </Box>
    );
  }

  // Se há result_docx, mostrar o arquivo usando o componente FileDownload
  return (
    <Box className={classes.container}>
      <FileDownload 
        file={outputPayload.result_docx}
        html_preview_token={outputPayload.result_docx.html_preview_token}
      />
    </Box>
  );
};

export default ContestacaoOutputDisplay; 